module.exports = __webpack_public_path__ + "static/media/copy-icon.6a727779.svg";